import { api } from './api';

export const relatorioEstoqueService = {
  gerarRelatorioEstoquePorLinha: async (): Promise<Blob> => {
    const response = await api.get<Blob>('/api/Produto/GerarRelatorioEstoquePorLinha');
    return response.data;
  },

  gerarRelatorioEstoquePorReferencia: async (): Promise<Blob> => {
    const response = await api.get<Blob>('/api/Produto/GerarRelatorioEstoquePorReferencia');
    return response.data;
  },
};
